import { Link } from "react-router-dom";


export default function FinalCTASection() {
  return (
    <section id="download" className="py-16 lg:py-24 bg-gradient-to-br from-[#4C6FFF] to-[#3B5EEE]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
          Download Vollet and take control of your crypto
        </h2>
        <p className="text-lg text-white/80 mb-10 max-w-2xl mx-auto">
          Join thousands of users who trust Vollet for their everyday crypto needs.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
          <Link to="/comingsoon"

            className="bg-white hover:bg-gray-100 text-gray-900 px-8 py-4 rounded-xl font-medium transition-colors cursor-pointer inline-flex items-center justify-center gap-3 whitespace-nowrap"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-google-play-fill text-xl"></i>
            </div>
            <div className="text-left">
              <p className="text-xs text-gray-500">Get it on</p>
              <p className="font-semibold">Google Play</p>
            </div>
          </Link>
          <Link to="/comingsoon"
            className="bg-white hover:bg-gray-100 text-gray-900 px-8 py-4 rounded-xl font-medium transition-colors cursor-pointer inline-flex items-center justify-center gap-3 whitespace-nowrap"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-apple-fill text-xl"></i>
            </div>
            <div className="text-left">
              <p className="text-xs text-gray-500">Download on the</p>
              <p className="font-semibold">App Store</p>
            </div>
          </Link>
        </div>

        {/* QR Code Placeholder */}
        <div className="inline-flex flex-col items-center">
          <div className="w-32 h-32 bg-white rounded-xl flex items-center justify-center mb-3">
            <i className="ri-qr-code-line text-4xl text-gray-300"></i>
          </div>
          <p className="text-sm text-white/70">Scan to download</p>
        </div>
      </div>
    </section>
  );
}
